import React from 'react';
import Modal from 'react-responsive-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  onCancelText: string;
  onConfirmText: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  onCancelText,
  onConfirmText,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      center
      classNames={{
        overlay: 'confirmModalOverlay',
        modal: 'confirmModal',
      }}
      showCloseIcon={false}
      animationDuration={150}>
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h4>{title}</h4>
          </div>
          <div className="modal_footer">
            <button onClick={onCancel} className="cancel">
              {onCancelText}
            </button>
            <button onClick={() => onConfirm()} className="confirm">
              {onConfirmText}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};
export default ConfirmModal;

const Style = styled.div`
  .modal {
    width: 100%;
    padding: 8% 10%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;
    text-align: center;
  }
  .modal_header {
    h4 {
      font-weight: 500;
      color: #555555;
      line-height: 36px;
      white-space: pre-line;
    }
  }

  .modal_footer {
    width: 100%;
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  button {
    flex: 1;
    width: 100%;
    padding: 8px 0;
    border-radius: 10px;
    font-size: 18px;
    line-height: 36px;
    font-weight: 500;
  }
  button.cancel {
    background: #ffffff;
    border: 1px solid #cecece;
    color: #555555;
  }
  button.confirm {
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
    color: #ffffff;
  }
  
`;
